module.exports = __webpack_public_path__ + "static/media/loading.9c1aa225.gif";